var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 523.9 812.97",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1611,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.93 0l-130.7 232.3H0L130.6 0z",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.23 232.3h261.3L391.94 0H130.6z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 464.5l130.63-232.2L130.6 0 0 232.3z",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.88 812.97l130.7-232.3H523.9l-130.7 232.3z",
    opacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.58 580.67H1.28l130.6 232.3H393.2z",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.2 348.45L262.58 580.67l130.62 232.3 130.7-232.3z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidityLogo);
export default __webpack_public_path__ + "static/media/solidity-logo.589a9cd98be9924165a471b591844879.svg";
export { ForwardRef as ReactComponent };